import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";

const Section = ({ title, children }) => (
  <Reveal className="mt-12">
    <h2 className="font-heading text-xl sm:text-2xl font-semibold tracking-tight text-[#0F2C59]">{title}</h2>
    <div className="mt-4 space-y-4 text-base leading-relaxed text-slate-600">{children}</div>
  </Reveal>
);

export const MentionsLegales = () => (
  <div data-testid="mentions-legales-page">
    <PageHero eyebrow="Informations légales" title="Mentions légales" testid="mentions-legales-title" />
    <section className="py-14 md:py-20">
      <div className="container-site max-w-3xl">
        <Section title="Éditeur du site">
          <p>
            <strong>Aide au Monde et Santé</strong> — Association loi 1901
            <br />
            N° d'enregistrement préfectoral (RNA) : W952012935
            <br />
            2 rue des Amandiers, 95200 Sarcelles, France
            <br />
            Téléphone : 09 54 24 34 46
            <br />
            E-mail : aide.monde.et.sante@gmail.com
          </p>
        </Section>
        <Section title="Directeur de la publication">
          <p>Le président de l'association Aide au Monde et Santé.</p>
        </Section>
        <Section title="Hébergement">
          <p>
            Ce site est hébergé par un prestataire professionnel garantissant un niveau de
            sécurité et de disponibilité conforme aux standards en vigueur.
          </p>
        </Section>
        <Section title="Propriété intellectuelle">
          <p>
            L'ensemble des contenus de ce site (textes, images, logo) est la propriété de
            l'association Aide au Monde et Santé, sauf mention contraire. Toute reproduction sans
            autorisation écrite préalable est interdite.
          </p>
        </Section>
        <Section title="Informations médicales">
          <p>
            Les informations publiées sur ce site sont générales et données à titre indicatif.
            Elles ne remplacent en aucun cas l'avis, le diagnostic ou le traitement d'un
            médecin ou d'un professionnel de santé.
          </p>
        </Section>
        <Section title="Coordonnées bancaires — dons par virement">
          <p data-testid="legal-bank-details">
            Titulaire : Aide au Monde et Santé
            <br />
            Banque : Crédit Agricole
            <br />
            IBAN : FR76 1820 6002 2365 0593 6124 975
            <br />
            BIC : AGRIFRPP882
          </p>
        </Section>
      </div>
    </section>
  </div>
);

export const Confidentialite = () => (
  <div data-testid="confidentialite-page">
    <PageHero eyebrow="Vos données" title="Politique de confidentialité (RGPD)" testid="confidentialite-title" />
    <section className="py-14 md:py-20">
      <div className="container-site max-w-3xl">
        <Section title="Données collectées">
          <p>
            Nous collectons uniquement les données que vous nous transmettez volontairement :
            nom, adresse e-mail et message via le formulaire de contact ; adresse e-mail pour
            la newsletter ; montant et fréquence des dons effectués en ligne.
          </p>
        </Section>
        <Section title="Utilisation des données">
          <p>
            Ces données servent exclusivement à : répondre à vos messages, vous envoyer notre
            newsletter (si vous y avez consenti) et assurer le suivi des dons et reçus fiscaux.
            Elles ne sont jamais vendues ni partagées avec des tiers à des fins commerciales.
          </p>
        </Section>
        <Section title="Paiements">
          <p>
            Les paiements en ligne sont traités par PayPal. L'association ne reçoit ni ne
            conserve jamais vos données bancaires.
          </p>
        </Section>
        <Section title="Vos droits">
          <p>
            Conformément au Règlement Général sur la Protection des Données (RGPD), vous
            disposez d'un droit d'accès, de rectification, d'opposition et de suppression de vos
            données. Pour l'exercer, écrivez à aide.monde.et.sante@gmail.com ou par courrier à :
            Aide au Monde et Santé, 2 rue des Amandiers, 95200 Sarcelles.
          </p>
        </Section>
        <Section title="Durée de conservation">
          <p>
            Les messages de contact sont conservés 12 mois. Les inscriptions à la newsletter
            sont conservées jusqu'à votre désinscription. Les données relatives aux dons sont
            conservées selon les obligations légales et comptables en vigueur.
          </p>
        </Section>
      </div>
    </section>
  </div>
);
